import React from 'react'
import Footer1 from '../components/Footers/Footer1.component'
import AuthHeader from '../components/Headers/AuthHeader.component'
import Paypal from '../components/Payments/Paypal.component'

export default function Payments() {
  return (
    <>
        <AuthHeader />

            <Paypal />

        <Footer1 />
    </>
  )
}
